import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-partner-code-popover',
  templateUrl: './partner-code-popover.component.html',
  styleUrls: ['./partner-code-popover.component.scss'],
  standalone: false,
})
export class PartnerCodePopoverComponent implements OnInit {
  @Input() employee;

  constructor() {}

  ngOnInit() {}
}
